import { SET_ADDPRODUCT } from '../actions';

const productadd = (state = [], action) => {
  switch (action.type) {
	case SET_ADDPRODUCT:
      return [...action.value];  
    default: return state;
  }
}

export default productadd;
